(function(){
  'use strict';

  // ── Lightbox ─────────────────────────────────────────────────────
  // 1st tap on slide  → open lightbox
  // 2nd tap on image  → zoom in (2x)
  // 3rd tap on image  → zoom out (1x)
  // tap outside image → close lightbox
  // swipe left/right  → go to next/previous slide (while not zoomed in)
  //
  // Navigating inside the lightbox (arrows, swipe, arrow keys) now steps
  // through EVERY slide in order, videos included: a video slide plays
  // in the lightbox (with controls) instead of being skipped. Images
  // keep the tap-to-zoom behaviour; videos don't zoom.
  var lb = null;

  function buildLightbox() {
    if (lb) return;

    var overlay = document.createElement('div');
    overlay.id = 'craft-lightbox';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.92);display:flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity 0.2s ease;';

    var img = document.createElement('img');
    img.alt = '';
    img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;transform-origin:center center;transition:transform 0.25s ease;display:block;';

    var vid = document.createElement('video');
    vid.controls = true;
    vid.loop = true;
    vid.muted = true;
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;display:none;background:#000;';

    var frameWrap = document.createElement('div');
    frameWrap.style.cssText = 'width:100%;max-width:960px;aspect-ratio:16/9;display:none;';

    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:16px;right:16px;background:none;border:none;color:#fff;font-size:36px;line-height:1;cursor:pointer;padding:8px;z-index:2;';

    var prevBtn = document.createElement('button');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#555555" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.style.cssText = 'position:absolute;top:50%;left:12px;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:10px;z-index:2;';

    var nextBtn = document.createElement('button');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#555555" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.style.cssText = 'position:absolute;top:50%;right:12px;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:10px;z-index:2;';

    overlay.appendChild(img);
    overlay.appendChild(vid);
    overlay.appendChild(frameWrap);
    overlay.appendChild(closeBtn);
    overlay.appendChild(prevBtn);
    overlay.appendChild(nextBtn);
    document.body.appendChild(overlay);
    lb = { overlay: overlay, img: img, vid: vid, frameWrap: frameWrap, zoomed: false, slider: null, index: 0, prevBtn: prevBtn, nextBtn: nextBtn };

    var touchStartX = 0, touchStartY = 0, touchMoved = false, justSwiped = false;

    // Tap image: toggle zoom (suppressed if the tap was actually a swipe)
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      if (justSwiped) { justSwiped = false; return; }
      lb.zoomed = !lb.zoomed;
      lb.img.style.transform = lb.zoomed ? 'scale(2)' : 'scale(1)';
    });

    // Taps on the video / embedded video use their own controls and must
    // not close the lightbox.
    vid.addEventListener('click', function(e) { e.stopPropagation(); });
    frameWrap.addEventListener('click', function(e) { e.stopPropagation(); });

    // Tap overlay (outside image): close
    overlay.addEventListener('click', function() {
      closeLightbox();
    });

    // Close button
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeLightbox();
    });

    prevBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      lightboxNav(-1);
    });
    nextBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      lightboxNav(1);
    });

    // Swipe navigation. Only active while not zoomed in, so pinch/pan on a
    // zoomed image isn't misread as a slide-change gesture.
    overlay.addEventListener('touchstart', function(e) {
      if (lb.zoomed) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMoved = false;
    }, {passive: true});

    overlay.addEventListener('touchmove', function(e) {
      if (lb.zoomed) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        touchMoved = true;
      }
    }, {passive: true});

    overlay.addEventListener('touchend', function(e) {
      if (lb.zoomed || !touchMoved) return;
      var dx = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) {
        justSwiped = true;
        dx > 0 ? lightboxNav(1) : lightboxNav(-1);
        setTimeout(function(){ justSwiped = false; }, 300);
      }
      touchMoved = false;
    });

    // Keyboard arrow-key navigation while the lightbox is open.
    document.addEventListener('keydown', function(e) {
      if (!lb || lb.overlay.style.pointerEvents !== 'auto') return;
      if (e.key === 'ArrowLeft') lightboxNav(-1);
      if (e.key === 'ArrowRight') lightboxNav(1);
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function lightboxStopMedia() {
    if (!lb) return;
    try { lb.vid.pause(); } catch (e) {}
    lb.vid.style.display = 'none';
    lb.frameWrap.innerHTML = '';
    lb.frameWrap.style.display = 'none';
  }

  // Shows slide idx inside the lightbox: the zoom photo for an image
  // slide, or the slide's video (or embedded video) for a video slide.
  function lightboxShow(idx) {
    if (!lb.slider) return;
    var slide = lb.slider.slides[idx];
    if (!slide) return;
    lb.index = idx;
    lb.zoomed = false;
    lightboxStopMedia();

    var src = slide.getAttribute('data-zoom');
    if (src) {
      lb.img.style.display = 'block';
      lb.img.style.transition = 'none';
      lb.img.style.transform = 'scale(1)';
      lb.img.src = src;
      requestAnimationFrame(function() { lb.img.style.transition = 'transform 0.25s ease'; });
      return;
    }

    lb.img.style.display = 'none';
    var v = slide.querySelector('video');
    if (v) {
      var vsrc = v.currentSrc || v.getAttribute('src') || '';
      if (!vsrc) {
        var sources = v.querySelectorAll('source');
        for (var i = 0; i < sources.length; i++) {
          var t = (sources[i].getAttribute('type') || '').toLowerCase();
          if (!vsrc || t.indexOf('mp4') !== -1) vsrc = sources[i].getAttribute('src');
          if (t.indexOf('mp4') !== -1) break;
        }
      }
      if (v.poster) lb.vid.poster = v.poster;
      if (lb.vid.getAttribute('src') !== vsrc) lb.vid.src = vsrc;
      lb.vid.style.display = 'block';
      lb.vid.muted = true;
      var p = lb.vid.play();
      if (p && p.catch) p.catch(function(){});
      try { v.pause(); } catch (e) {}
      return;
    }
    var f = slide.querySelector('iframe');
    if (f) {
      var clone = f.cloneNode(true);
      clone.style.cssText = 'width:100%;height:100%;border:0;display:block;';
      lb.frameWrap.appendChild(clone);
      lb.frameWrap.style.display = 'block';
    }
  }

  function lightboxUpdateArrows() {
    if (!lb.slider) { lb.prevBtn.style.display = 'none'; lb.nextBtn.style.display = 'none'; return; }
    var multiple = lb.slider.count > 1;
    lb.prevBtn.style.display = multiple ? '' : 'none';
    lb.nextBtn.style.display = multiple ? '' : 'none';
  }

  // Moves the lightbox to the next/previous slide in the given direction
  // -- photos AND videos, in the same order as the gallery -- and keeps
  // the underlying slider's position in sync, so closing the lightbox
  // lands back on the same slide that was just being viewed.
  function lightboxNav(direction) {
    if (!lb.slider) return;
    var count = lb.slider.count;
    if (count < 1) return;
    var idx = (lb.index + direction + count) % count;
    lb.slider.goTo(idx, false);
    lightboxShow(idx);
  }

  function openLightbox(src, sliderInstance, idx) {
    buildLightbox();
    lb.slider = sliderInstance;
    lightboxShow(idx);
    lb.overlay.style.pointerEvents = 'auto';
    lightboxUpdateArrows();
    requestAnimationFrame(function() {
      lb.overlay.style.opacity = '1';
    });
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lb) return;
    lb.overlay.style.opacity = '0';
    lb.overlay.style.pointerEvents = 'none';
    lb.zoomed = false;
    lb.img.style.transform = 'scale(1)';
    lightboxStopMedia();
    document.body.style.overflow = '';
  }

  // ── Slider ────────────────────────────────────────────────────────
  function CraftSlider(wrap) {
    this.wrap       = wrap;
    this.inner      = wrap.querySelector('.craft-slider-inner');
    this.track      = wrap.querySelector('.craft-slider-track');
    this.slides     = wrap.querySelectorAll('.craft-slide');
    this.count      = this.slides.length;
    this.cur        = 0;
    this.startX     = 0;
    this.startY     = 0;
    this.isDragging = false;
    this.dragMoved  = false;
    this._thumbClicking = false;

    var sectionId = wrap.getAttribute('data-section');
    this.thumbsWrap = sectionId ? document.querySelector('.craft-thumbs-wrap[data-section="' + sectionId + '"]') : null;

    wrap.querySelectorAll('.craft-slide .imgWrapper').forEach(function(el) {
      el.removeAttribute('style');
    });

    wrap.setAttribute('data-count', this.count);
    this._buildArrows();
    this._buildDots();
    this._buildThumbs();
    this._buildThumbNav();
    this._bindEvents();
    this._bindTapZoom();
    this.goTo(0, false);
    this._preloadAllImages();

    var self = this;

    // Keep the slide position pixel-perfect on resize/zoom. We position
    // slides with an exact-pixel transform (see goTo) rather than a
    // percentage transform, so the track width must be re-measured whenever
    // it can change — otherwise a stale pixel offset from before the resize
    // would show a hairline sliver of the next slide at the edge.
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        self.goTo(self.cur, false);
      }, 100);
    });

    if (self.thumbsWrap) {
      self.thumbsWrap.style.scrollBehavior = 'auto';
      self.thumbsWrap.scrollLeft = 0;
      self.thumbsWrap.scrollTop = 0;
      requestAnimationFrame(function() {
        self.thumbsWrap.style.scrollBehavior = '';
        if (self._updateThumbArrows) self._updateThumbArrows();
      });
    }
  }

  // Force every slide image to start downloading right away, instead of
  // waiting on lazysizes' viewport/IntersectionObserver-based loading.
  // Our slides sit off-screen (revealed only via CSS transform inside an
  // overflow:hidden track), so lazysizes can be slow — or in some cases
  // never — to notice a slide has become "visible". We resolve each
  // image's real source ourselves and assign it directly, and also warm
  // the larger full-resolution "zoom" image (data-zoom) used by the
  // lightbox, so it swaps in instantly when someone taps to open it.
  CraftSlider.prototype._preloadAllImages = function() {
    this.slides.forEach(function(slide) {
      var img = slide.querySelector('img.lazyload, img[data-src]');
      if (img) {
        var fullSrc = img.getAttribute('data-src');
        if (fullSrc) {
          var resolvedSrc = fullSrc.indexOf('{width}') !== -1 ? fullSrc.replace('{width}', '1300') : fullSrc;
          img.src = resolvedSrc;
          img.removeAttribute('data-src');
        }

        var fullSrcset = img.getAttribute('data-srcset');
        if (fullSrcset) {
          img.srcset = fullSrcset;
          img.removeAttribute('data-srcset');
        }

        img.removeAttribute('data-sizes');
        img.classList.remove('lazyload', 'lazypreload');
        img.classList.add('lazyloaded');
      }

      var zoomSrc = slide.getAttribute('data-zoom');
      if (zoomSrc) {
        var zoomPreload = new Image();
        zoomPreload.src = zoomSrc;
      }
    });
  };

  CraftSlider.prototype._buildThumbs = function() {
    if (!this.thumbsWrap) return;
    this.thumbItems = this.thumbsWrap.querySelectorAll('.craft-thumb-item');
    var self = this;
    this.thumbItems.forEach(function(item, idx) {
      item.addEventListener('click', function(e) {
        if (self._thumbDragMoved) { e.preventDefault(); e.stopPropagation(); return; }
        self._thumbClicking = true;
        self.goToFade(idx);
        setTimeout(function(){ self._thumbClicking = false; }, 100);
      });
    });
  };

  CraftSlider.prototype._bindTapZoom = function() {
    var self = this;
    self.slides.forEach(function(slide, idx) {
      if (slide.classList.contains('videoSlide')) return;
      slide.addEventListener('click', function() {
        if (self._thumbClicking) return;
        if (self.dragMoved) return;
        var src = slide.getAttribute('data-zoom');
        if (src) openLightbox(src, self, idx);
      });
    });
  };

  CraftSlider.prototype._buildArrows = function() {
    var self = this;
    this.prevBtn = this._makeEl('button', 'craft-arrow prev', '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>');
    this.nextBtn = this._makeEl('button', 'craft-arrow next', '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>');
    this.prevBtn.setAttribute('aria-label', 'Previous');
    this.nextBtn.setAttribute('aria-label', 'Next');
    this.wrap.appendChild(this.prevBtn);
    this.wrap.appendChild(this.nextBtn);
    this.prevBtn.addEventListener('click', function(){ self.prev(); });
    this.nextBtn.addEventListener('click', function(){ self.next(); });
  };

  CraftSlider.prototype._buildDots = function() {
    if (this.count <= 1) return;
    var self = this;
    this.dotsWrap = this._makeEl('div', 'craft-dots', '');
    this.dots = [];
    for (var i = 0; i < this.count; i++) {
      var d = this._makeEl('button', 'craft-dot', '');
      d.setAttribute('aria-label', 'Go to slide ' + (i+1));
      (function(idx){ d.addEventListener('click', function(){ self.goTo(idx); }); })(i);
      this.dotsWrap.appendChild(d);
      this.dots.push(d);
    }
    this.wrap.parentNode.insertBefore(this.dotsWrap, this.wrap.nextSibling);
  };

  CraftSlider.prototype._buildThumbNav = function() {
    if (!this.thumbsWrap) return;
    var self = this;
    var strip = this.thumbsWrap;
    var row = document.createElement('div');
    row.className = 'craft-thumbs-row';
    var tPrev = this._makeEl('button', 'craft-thumb-arrow thumb-prev', '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>');
    var tNext = this._makeEl('button', 'craft-thumb-arrow thumb-next', '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>');
    tPrev.setAttribute('aria-label', 'Scroll thumbnails up');
    tNext.setAttribute('aria-label', 'Scroll thumbnails down');
    strip.parentNode.insertBefore(row, strip);
    row.appendChild(tPrev);
    row.appendChild(strip);
    row.appendChild(tNext);
    var thumbSize = 54;

    // Desktop lays the thumb strip out as a vertical column (scrolls up/
    // down); mobile lays it out as a horizontal row (scrolls left/right).
    var isVerticalNav = window.innerWidth >= 768;

    tPrev.addEventListener('click', function(){
      if (isVerticalNav) strip.scrollBy({ top: -(thumbSize * 2), behavior: 'smooth' });
      else strip.scrollBy({ left: -(thumbSize * 2), behavior: 'smooth' });
    });
    tNext.addEventListener('click', function(){
      if (isVerticalNav) strip.scrollBy({ top: thumbSize * 2, behavior: 'smooth' });
      else strip.scrollBy({ left: thumbSize * 2, behavior: 'smooth' });
    });
    function updateThumbArrows() {
      if (isVerticalNav) {
        tPrev.classList.toggle('hidden', strip.scrollTop <= 2);
        tNext.classList.toggle('hidden', strip.scrollTop + strip.offsetHeight >= strip.scrollHeight - 2);
      } else {
        tPrev.classList.toggle('hidden', strip.scrollLeft <= 2);
        tNext.classList.toggle('hidden', strip.scrollLeft + strip.offsetWidth >= strip.scrollWidth - 2);
      }
    }
    strip.addEventListener('scroll', updateThumbArrows, { passive: true });
    setTimeout(updateThumbArrows, 200);
    this._updateThumbArrows = updateThumbArrows;

    // ── Click-and-drag scrolling on the thumbnail strip itself ───────────
    var isVertical = window.innerWidth >= 768;
    var dragStartPos = 0;
    var dragStartScroll = 0;
    var dragging = false;
    self._thumbDragMoved = false;

    strip.addEventListener('mousedown', function(e){
      dragging = true;
      self._thumbDragMoved = false;
      dragStartPos = isVertical ? e.clientY : e.clientX;
      dragStartScroll = isVertical ? strip.scrollTop : strip.scrollLeft;
      strip.style.cursor = 'grabbing';
      strip.style.scrollBehavior = 'auto';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e){
      if (!dragging) return;
      var pos = isVertical ? e.clientY : e.clientX;
      var delta = pos - dragStartPos;
      if (Math.abs(delta) > 4) self._thumbDragMoved = true;
      if (isVertical) {
        strip.scrollTop = dragStartScroll - delta;
      } else {
        strip.scrollLeft = dragStartScroll - delta;
      }
    });
    document.addEventListener('mouseup', function(){
      if (!dragging) return;
      dragging = false;
      strip.style.cursor = '';
      strip.style.scrollBehavior = '';
      updateThumbArrows();
      setTimeout(function(){ self._thumbDragMoved = false; }, 50);
    });
  };

  CraftSlider.prototype._scrollThumbIntoView = function(idx) {
    if (!this.thumbItems || !this.thumbsWrap) return;
    var thumb = this.thumbItems[idx];
    if (!thumb) return;
    var strip = this.thumbsWrap;
    var isVertical = window.innerWidth >= 768;

    if (isVertical) {
      var tTop = thumb.offsetTop;
      var tBottom = tTop + thumb.offsetHeight;
      var sTop = strip.scrollTop;
      var sHeight = strip.clientHeight;
      if (tTop < sTop) {
        strip.scrollTo({ top: tTop - 6, behavior: 'smooth' });
      } else if (tBottom > sTop + sHeight) {
        strip.scrollTo({ top: tBottom - sHeight + 6, behavior: 'smooth' });
      }
    } else {
      var stripRect = strip.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var overflowRight = thumbRect.right - stripRect.right;
      var overflowLeft = stripRect.left - thumbRect.left;
      if (overflowRight > 0) {
        strip.scrollBy({ left: overflowRight + 8, behavior: 'smooth' });
      } else if (overflowLeft > 0) {
        strip.scrollBy({ left: -(overflowLeft + 8), behavior: 'smooth' });
      }
    }

    if (this._updateThumbArrows) this._updateThumbArrows();
  };

  CraftSlider.prototype._bindEvents = function() {
    var self = this;
    var track = this.wrap.querySelector('.craft-slider-track');
    track.addEventListener('touchstart', function(e){
      self.startX = e.touches[0].clientX;
      self.startY = e.touches[0].clientY;
    }, {passive: true});
    track.addEventListener('touchend', function(e){
      var dx = self.startX - e.changedTouches[0].clientX;
      var dy = self.startY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        dx > 0 ? self.next() : self.prev();
      }
    }, {passive: true});
    track.addEventListener('mousedown', function(e){
      if (e.button !== 0) return;
      self.startX = e.clientX;
      self.isDragging = true;
      self.dragMoved = false;
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e){
      if (!self.isDragging) return;
      if (Math.abs(e.clientX - self.startX) > 5) self.dragMoved = true;
    });
    document.addEventListener('mouseup', function(e){
      if (!self.isDragging) return;
      self.isDragging = false;
      if (!self.dragMoved) return;
      var dx = self.startX - e.clientX;
      if (Math.abs(dx) > 40) { dx > 0 ? self.next() : self.prev(); }
      self.dragMoved = false;
    });
    track.addEventListener('click', function(e){
      if (self.dragMoved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    self.wrap.setAttribute('tabindex', '0');
    self.wrap.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') self.prev();
      if (e.key === 'ArrowRight') self.next();
    });
  };

  // Pixel-perfect positioning: read the track's real pixel width and
  // round once, instead of a percentage translateX that can leave a
  // hairline sliver of the next slide visible at the edge.
  CraftSlider.prototype._trackWidth = function() {
    return (this.track || this.wrap).getBoundingClientRect().width;
  };

  CraftSlider.prototype.goTo = function(idx, animate) {
    if (idx < 0) idx = this.count - 1;
    if (idx >= this.count) idx = 0;
    this.cur = idx;
    var offsetPx = Math.round(idx * this._trackWidth());
    this.inner.style.transition = (animate === false) ? 'none' : 'transform 0.35s cubic-bezier(.4,0,.2,1)';
    this.inner.style.transform = 'translate3d(-' + offsetPx + 'px, 0, 0)';
    if (this.dots) this.dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
    if (this.thumbItems) this.thumbItems.forEach(function(t,i){ t.classList.toggle('active', i===idx); });
    this._scrollThumbIntoView(idx);
    this.slides.forEach(function(slide, i) {
      var videos = slide.querySelectorAll('video');
      var iframes = slide.querySelectorAll('iframe');
      if (i === idx) {
        videos.forEach(function(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      } else {
        videos.forEach(function(v) { v.pause(); });
        iframes.forEach(function(f) { if (f.src) f.src = f.src; });
      }
    });
  };

  // Instant jump — used for swatch/variant-driven photo changes AND for
  // direct thumbnail clicks (every gallery image is already preloaded).
  CraftSlider.prototype.goToFade = function(idx) {
    if (idx < 0 || idx >= this.count) return;
    if (idx === this.cur) return;
    this.goTo(idx, false);
  };

  CraftSlider.prototype.prev = function() { this.goTo(this.cur - 1); };
  CraftSlider.prototype.next = function() { this.goTo(this.cur + 1); };
  CraftSlider.prototype._makeEl = function(tag, cls, html) {
    var el = document.createElement(tag); el.className = cls; el.innerHTML = html; return el;
  };

  function initAll() {
    document.querySelectorAll('.craft-slider-wrap').forEach(function(wrap){
      if (!wrap._craftSlider) wrap._craftSlider = new CraftSlider(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  if (window.jQuery) jQuery(function(){ initAll(); });

  window.CraftSlider = { init: initAll };
})();
